import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import ChatListsActions from '../actions/chat'

export const useChats = () => {
  const data = useSelector((state) => {
    return get(state, 'app.chatListsManagement')
  })

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(ChatListsActions, dispatch),
    [dispatch],
  )

  return {
    actions,
    data,
  }
}
